import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { COUNTRY_CODES } from 'constants/countries'
import { ControlledSelectField } from 'components/Shared/ControlledSelectField'

export function CountrySelectField ({ name, label, ...rest }) {
  const { t } = useTranslation()

  const countrySelectItems = useMemo(() =>
      COUNTRY_CODES
        .map(code => ({ id: code, label: t(`countries.${code}`) }))
        .sort((i1, i2) => i1.label.localeCompare(i2.label)),
    [t])

  return (
    <ControlledSelectField
      options={countrySelectItems}
      getOptionLabel={item => item.label}
      label={t(label)}
      fieldName={name}
      disableClear
      {...rest}
    />
  )
}
